import { useId } from "react";

import { Input } from "@/DesignSystem/shadcn/Input";
import { Label } from "@/DesignSystem/shadcn/Label/Label";
import { cn } from "@/lib/utils";

export type SimpleInputType = {
  containerClassName?: string;
  labelClassName?: string;
  inputClassName?: string;

  fieldName?: string;
  disabled?: boolean;
  required?: boolean;

  label?: string;
  placeholder?: string;
  type?: string;
  helpText?: string;

  value: string;
  onChange?: (value: string) => void;

  errorMessage?: string;

  onBlur?: () => void;
};

export const VariationGreyInputClassName = "bg-dark border-highlightDeep placeholder:text-placeholder max-w-[300px]";

export const SimpleInput = ({
  containerClassName,
  labelClassName,
  inputClassName,

  fieldName,
  label,
  placeholder,
  disabled,
  type,
  helpText,

  value,
  onChange,

  errorMessage,

  onBlur,
  required,
}: SimpleInputType) => {
  const id = useId();

  // Use auto-generated ID if fieldName is not provided
  if (!fieldName) {
    fieldName = id;
  }

  return (
    <div className={cn("flex flex-col gap-2", containerClassName)}>
      {label ? (
        <Label data-testid={"label_" + fieldName} htmlFor={fieldName} className={labelClassName}>
          {label}
        </Label>
      ) : null}

      <Input
        id={fieldName}
        placeholder={placeholder ?? ""}
        value={value ? value : ""}
        className={inputClassName}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value)}
        onBlur={onBlur}
        type={type ?? "text"}
        required={required}
      />
      {helpText ? <p className="text-sm italic pl-2">{helpText}</p> : null}
      {errorMessage ? <p>{errorMessage}</p> : null}
    </div>
  );
};
